export const getOnlyDigitalString = (str: string = '') => str?.replace(/[^+\d]/g, '')
